export const collectionConstants = {
  GETALL_REQUEST: 'COLLECTIONS_GETALL_REQUEST',
  GETALL_SUCCESS: 'COLLECTIONS_GETALL_SUCCESS',
  GETALL_FAILURE: 'COLLECTIONS_GETALL_FAILURE',

  GET_REQUEST: 'COLLECTIONS_GET_REQUEST',
  GET_SUCCESS: 'COLLECTIONS_GET_SUCCESS',
  GET_FAILURE: 'COLLECTIONS_GET_FAILURE',

  ADD_REQUEST: 'COLLECTIONS_ADD_REQUEST',
  ADD_SUCCESS: 'COLLECTIONS_ADD_SUCCESS',
  ADD_FAILURE: 'COLLECTIONS_ADD_FAILURE',

  UPDATE_REQUEST: 'COLLECTIONS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'COLLECTIONS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'COLLECTIONS_UPDATE_FAILURE',
}